<template>
    <div class="file-drop-wrapper" :class="{dragover:fileDragOver}" ref="fileDropzone">
        <p v-if="dragDropFileCapable && !isUploading" class="drop-file-text">Drop Files Here...</p>
        <add-attachment-btn v-if="!isUploading" :multiple="multiple" :bus="bus"></add-attachment-btn>
        <start-upload-btn v-if="filesCount > 0" :filesCount="filesCount" :isUploading="isUploading" :bus="bus"></start-upload-btn>
        <cancel-upload-btn v-if="filesCount > 0" :isUploading="isUploading" :bus="bus"></cancel-upload-btn>
    </div>
</template>

<script>
    import attachFileButtonComponent from './port-fileupload-file-browser-button.vue';
    import startUploadButtonComponent from './port-fileupload-start-upload-button.vue';
    import cancelUploadButtonComponent from './port-fileupload-cancel-upload-button.vue';

    export default {
        props: ["filesCount", "isUploading", "multiple", "bus"],
        data: function () {
            return {
                dragDropFileCapable: true,
                fileDragOver: false
            };
        },
        mounted: function () {
            ["drag", "dragstart", "dragend", "dragover", "dragenter", "dragleave", "drop"].forEach(function (evt) {
                /*
                    For each event add an event listener that prevents the default action
                    (opening the file in the browser) and stop the propagation of the event (so
                    no other elements open the file in the browser)
                */
                this.$refs.fileDropzone.addEventListener(evt, function (e) {
                    e.preventDefault();
                    e.stopPropagation();
                }.bind(this), false);
            }.bind(this));

            this.$refs.fileDropzone.addEventListener('dragover', function (e) {
                this.fileDragOver = true;
            }.bind(this));

            this.$refs.fileDropzone.addEventListener('dragleave', function (e) {
                this.fileDragOver = false;
            }.bind(this));

            this.$refs.fileDropzone.addEventListener('drop', function (e) {
                this.fileDragOver = false;
                bus.emit("filesSelected", e.dataTransfer.files);
            }.bind(this));

        },
        components: {
            "add-attachment-btn": attachFileButtonComponent,
            "start-upload-btn": startUploadButtonComponent,
            "cancel-upload-btn": cancelUploadButtonComponent
        }
    }
</script>